import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Group } from '../model/group';
import { getGroups } from '../api/groups';

interface GroupState {
  groups: Group[]
  currentGroup: Group | null
}

const initialState: GroupState = {
  groups: [],
  currentGroup: null 
};

const groupSlice = createSlice({
  name: 'group',
  initialState,
  reducers: {
    setCurrentGroup: (state, action: PayloadAction<Group>) => {
      state.currentGroup = action.payload;
    }
  },

  extraReducers: (builder) => {
    builder
      .addCase(getGroupsAsync.fulfilled, (state: GroupState, action: PayloadAction<Group[]>) => {
        state.groups = action.payload;
      })
      .addCase(getGroupsAsync.rejected, (state: GroupState, action) => {
        console.error(action.error.message);
      })
    },
});

export const getGroupsAsync = createAsyncThunk('program/getGroupsAsync', async ({ accessToken }: { accessToken: string}) => {
    const response = await getGroups(accessToken);
    return response;
  }
);

export const { setCurrentGroup} = groupSlice.actions;
export default groupSlice.reducer;